export const dynamicStyles = {
  CLIENT_STYLES: 'clientCustomStyles',
}

/**
 * Allows to inject dynamic styles
 * @todo Add unit test somehow
 */
export default function useDynamicStyleInjector() {
  return {
    injectOrReplaceStyleSheet,
    removeStyleSheet,
    removeAllDynamicStyleSheets,
  }
}

/**
 *
 * @param {string} tagId
 */
function removeStyleSheet(tagId: string) {
  const linkElement = document.getElementById(tagId) as HTMLLinkElement
  if (linkElement) {
    linkElement.parentNode?.removeChild(linkElement)
  }
  console.log('useDynamicStyleInjector - removeStyleSheet - ' + tagId)
}

/**
 *
 * @param {string} tagId unique identifier
 * @param {string} styleSheetString
 * @returns {boolean} success
 */
function injectOrReplaceStyleSheet(tagId: string, styleSheetString: string) {
  if (!isValidStyleSheetString(styleSheetString)) {
    console.warn(
      'useDynamicStyleInjector - Invalid stylesheet provided',
      styleSheetString
    )
    return false
  } else {
    insertOrReplaceStyleSheetInHead(tagId, styleSheetString)
    styleSheetString = decodeURI(styleSheetString) //If style provided by env using querystring
    console.log(
      'useDynamicStyleInjector - injectOrReplaceStyleSheet - ' + tagId,
      `(${styleSheetString} chars)`
    )
    return true
  }
}

/**
 * Creates or updates an style tag and insert into head, before the closing tag.
 * @param tagId unique identifier
 * @param styleSheetString
 * @return {void}
 */
function insertOrReplaceStyleSheetInHead(
  tagId: string,
  styleSheetString: string
): void {
  const head = document.head
  const styleTag = document.getElementById(tagId)

  if (styleTag) {
    styleTag.innerHTML = styleSheetString
  } else {
    const newStyleTag = document.createElement('style')
    newStyleTag.setAttribute('type', 'text/css')
    newStyleTag.id = tagId
    newStyleTag.innerHTML = styleSheetString
    head.insertAdjacentElement('beforeend', newStyleTag)
  }
}

/**
 *
 * @param {string} styleSheetString
 * @returns {boolean}
 */
function isValidStyleSheetString(styleSheetString: string): boolean {
  // Create a new style element
  const style = document.createElement('style')

  // Set the innerHTML of the style element to the provided styleSource
  style.innerHTML = styleSheetString

  // Append the style element to the document head
  document.head.appendChild(style)

  // Check if the style element has a valid sheet property
  try {
    const sheet = style.sheet
    if (!sheet) {
      // Remove the style element from the document head
      document.head.removeChild(style)
      return false
    }
  } catch (error) {
    // Remove the style element from the document head
    document.head.removeChild(style)
    return false
  }

  // Remove the style element from the document head
  document.head.removeChild(style)

  // Return true if the styleSource is valid
  return true
}

function removeAllDynamicStyleSheets(startIndex: string) {
  const dynamicStyleSheets = document.querySelectorAll(
    `style[id^=${startIndex}]`
  )
  dynamicStyleSheets.forEach((styleSheet) => {
    styleSheet.parentNode?.removeChild(styleSheet)
  })
}
